import type { ISingleResult } from "./types.js";

type Result = ISingleResult & {
	linkText: string;
};

/**
 * Renders a single result.
 *
 * @param element The result to render.
 * @returns The rendered result HTML.
 */
export function render(element: ISingleResult): string {
	const adjusted: Partial<Result> = { ...element };
	adjusted.image ||=
		"/wp-content/themes/rootree/assets/woocommerce-placeholder-300x300.png";

	switch (element.type) {
		case "page":
			adjusted.linkText = "View Page";
			break;
		case "portfolio":
			adjusted.linkText = "View Portfolio";
			break;
		case "post":
			adjusted.linkText = "View Post";
			break;
		case "product":
			adjusted.linkText = "View Product";
			break;
		default:
			adjusted.linkText = "View";
	}
	return template(adjusted as Result);
}

/**
 * Creates the HTML for a single result.
 *
 * @param element The result to render.
 * @returns The rendered result HTML.
 */
function template(element: Result) {
	const { blurb, image, linkText, permalink, title } = element;
	let resultHtml = `<div class="grid gap-8 grid-cols-[1fr_2fr] py-4 px-0">`;
	resultHtml += `    <img src="${image}" alt="${title}" class="rounded-xl" width="600" height="300">`;
	resultHtml += `<div>`;
	resultHtml += `    <h4><a href="${permalink}">${title}</a></h4>`;
	resultHtml += `    <p class="mb-4">`;
	resultHtml += `       ${blurb}`;
	resultHtml += `    </p>`;
	resultHtml += `    <div class="flex justify-end"><a href="${permalink}" class="rt-button">${linkText}</a></div>`;
	resultHtml += `</div>`;
	resultHtml += `</div>`;
	return resultHtml;
}
